import React, { useContext } from 'react';
import { AppContext } from 'Context';
import MembershipDemo from 'Pages/userManagement/MembershipDemo';
import membershipStyles from 'Pages/userManagement/MembershipDemo/index.module.css';
import { V2SettingsShell } from '../../_shared/V2SettingsShell';

// Settings → Affiliate Program (v2). The membership module is self-contained
// (own CSS module, light card theme), so the v2 layer only supplies the shell
// chrome — heading, sidebar, dock — around it. The affiliate code rides on the
// header line (top-right) instead of inside the user-management block.
export const AffiliateSettingsV2 = () => {
  const { apiResponse } = useContext(AppContext);
  const affiliateCode = apiResponse?.data?.[0]?.affiliateCode || '';
  return (
    <V2SettingsShell
      title="Affiliate Program"
      description="Your membership, the accounts you've created, and member pricing."
      headerAction={affiliateCode ? (
        <div className={membershipStyles.headerAffCode}>
          <span className={membershipStyles.headerAffCodeLabel}>Affiliate Code</span>
          <span className={membershipStyles.headerAffCodeVal}>{affiliateCode}</span>
        </div>
      ) : null}
    >
      <MembershipDemo />
    </V2SettingsShell>
  );
};

export default AffiliateSettingsV2;
